import { lazy } from 'react'

export const ActivateLicenseModalAsync = lazy(() =>
    import('./ActivateLicenseModal').then((module) => ({
        default: module.ActivateLicenseModal,
    }))
)
